export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_13.2844d2fa.jpg";